module.exports = __webpack_public_path__ + "img/logo-explicae-free.8411f454.svg";